/**
 * @desc 分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.SalesChannelResponseDto>
>;
export function request(
  params: API.basics.salesChannel.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/salesChannel/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
